export default __webpack_public_path__ + "static/media/image1.e2114f5b.jpg";